export const TEXTS = {
  APPLICATIONS_TAB: "Applications",
  APPLICATION_NAME_COL: "Application Name",
  VARIANT_COL: "Variant",
  CLIENT_HEADER: "Client Type details",
  CLIENT_HEADER_NEW: "Add new Client Type",
  CLIENT_DETAILS_TAB: "Client Type details",
  CLIENT_EDIT_TAB: "Edit details",
  CLIENT_DETAILS_HEADER: "Client details",
  CLIENT_NAME_LABEL: "Name",
  CLIENT_ID_LABEL: "ID",
  CLIENT_SLUG_LABEL: "Slug",
  OEM_HEADER: "OEM details",
  OEM_HEADER_NEW: "Add new OEM",
  OEM_DETAILS_TAB: "OEM details",
  OEM_EDIT_TAB: "Edit details",
  OEM_DETAILS_HEADER: "OEM details",
  OEM_NAME_LABEL: "Name",
  OEM_ID_LABEL: "ID",
  OEM_SLUG_LABEL: "Slug",
  OEM_RS_LABEL: "Applicable release stages",
  OEM_APPROVAL_LABEL: "Publication requires approval",
  OEM_WARNING_TITLE: "Action required!",
  OEM_WARNING_MISSING_PRESENTATION:
    "Presentation setup incomplete. Open each provider to add the missing presentation details",
  SUBMIT_BTN: "Submit changes",
  NO_VALUE: "-",
};

export const DEVICE_APPS_LIMIT = 50;
